import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  storedData: {}
}

const applicantData = createSlice({
  name: 'storedDataSlice',
  initialState,
  reducers: {
    addData: (state, action) => {
      state.storedData = action.payload.applicantData
    }

  }

})

export const {
  addData
} = applicantData.actions

export default applicantData.reducer;







